import script from "./ViewTgModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewTgModal.vue?vue&type=script&lang=ts&setup=true"

import "./ViewTgModal.vue?vue&type=style&index=0&id=6d32f936&lang=css"

const __exports__ = script;

export default __exports__